import type Leaflet from 'leaflet';
import React, { FunctionComponent, useCallback, useRef, useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import type ReactLeaflet from 'react-leaflet';
import type { Marker } from 'react-leaflet';
import { MarkerData } from '../classes/MarkerData';
import Box from '../../../elements/Box';
import { strFormatV2 } from '../../../../helpers/utils';

export interface AirportMarkerProps {
  marker: MarkerData;
  onClick?: (marker: MarkerData) => void;
  onMouseOver: (marker: MarkerData | undefined) => void;
  iconSettings?: $TSFixMe;
  iconSettingsStyles?: $TSFixMe;
  tooltipSettings?: $TSFixMe;
  airportNameSettings?: $TSFixMe;
  markerHover?: any;
  showAirportIataCode?: boolean;
  labelStructure?: string;
  isMapMode?: boolean;
  showTopOffers?: boolean;
}

export type AirportMarkerPropsType = AirportMarkerProps;

const getNewLabel = (marker: any, labelStructure: string) => {
  return strFormatV2(labelStructure, marker);
};
const AirportMarker: FunctionComponent<AirportMarkerPropsType> = (
  props: AirportMarkerPropsType
) => {
  const {
    onClick,
    onMouseOver,
    marker,
    iconSettings,
    iconSettingsStyles = {},
    tooltipSettings,
    airportNameSettings = {},
    labelStructure = '{city.name} ({iataCode})',
    isMapMode,
    markerHover,
    ...markerSettings
  } = props;

  const markerRef = useRef<Marker>(null);
  const { direction, theme } = useContext(Context);

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(marker);
    }
  }, [marker, onClick]);

  const { Marker, Tooltip } = require('react-leaflet') as typeof ReactLeaflet;
  const leaflet = require('leaflet') as typeof Leaflet;

  const renderTooltip = (
    <Tooltip
      interactive
      direction="top"
      className="filters"
      onclick={handleClick}
      {...tooltipSettings}
    >
      <Box className="fr-tooltip-airport-name" {...airportNameSettings}>
        {getNewLabel(marker, labelStructure)}
      </Box>
    </Tooltip>
  );

  const [iconClassName] = useStyles(iconSettingsStyles, { direction, theme });
  const icon = leaflet.divIcon({
    className: 'custom-div-icon',
    html: `<div class='marker-pin ${!isMapMode ? iconClassName : ''}' ></div>`,
    iconSize: [20, 20],
    ...iconSettings
  });

  return (
    <Marker
      position={marker.location}
      onclick={handleClick}
      icon={icon}
      ref={markerRef}
      keyboard={false}
      onmouseover={() => {
        onMouseOver(marker);
        markerRef.current?.leafletElement.openTooltip();
      }}
      onmouseout={() => {
        onMouseOver(undefined);
        markerRef.current?.leafletElement.closeTooltip();
      }}
      {...markerSettings}
    >
      {markerHover && markerHover.value === marker.value && renderTooltip}
    </Marker>
  );
};

export default React.memo(AirportMarker);
